import React from 'react';
import { Chip } from "@mui/material";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(theme => ({
    chipPendiente: {
        backgroundColor: '#FEF3C7',
        color: '#C0A000'
    },
    chipPagado: {
        backgroundColor: '#D1FAE5',
        color: '#00A73B'
    },
    chipFallido: {
        backgroundColor: '#FEE2E2',
        color: '#F25050'
    },
    chipAnulado: {
        backgroundColor: '#F3F4F6',
        color: '#374151'
    }
}));

interface AbonoEstadoProps {
   estado: string
}

export const AbonosEstadoChip: React.FC<AbonoEstadoProps> = ({estado}) => {
    const { classes } = useStyles();
    let className;
    switch (estado) {
        case "PENDIENTE":
            className = classes.chipPendiente;
            break;
        case "PAGADO":
            className = classes.chipPagado;
            break;
        case "FALLIDO":
            className = classes.chipFallido;
            break;
        default:
            className = classes.chipAnulado;
    }
    return <Chip label={estado} className={className} />;
};